export const baseImageUrl = "https://static.flashift.app";
